import { TripBookingPayment } from '../../lib/types/models/trip-booking/trip-booking-payment'
import { TripBookingPaymentInput } from '../../lib/types/models/trip-booking/trip-booking-payment-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripBookingPayment(
  input: TripBookingPaymentInput & { id: number; tripBookingId: number }
) {
  const { id, tripBookingId, ...data } = input
  return restApiClient
    .url(
      constructApiUrl(API['trip-bookings'].updatePayment.url, { id: tripBookingId, paymentId: id })
    )
    .patch<TripBookingPayment, TripBookingPaymentInput>(data)
}
